import Link from 'next/link';
import { useRouter } from 'next/router';

import { Breadcrumbs, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { Section, SectionAlternate } from '@/src/components/organisms';
import { useStickySWR } from '@/src/lib/hooks';
import { nextAPIfetcher } from '@/src/lib/utils';

import { Hero, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
  },
  sectionBreadcrumb: {
    '& .section-alternate__content': {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  sectionSearch: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

export default function BlogCategory({ doc }) {
  const router = useRouter();
  const classes = useStyles();

  const { page = 1, search = '' } = router.query;
  const { category = {}, posts } = doc || {};
  const { id: categoryId } = category;

  const { data, isValidating } = useStickySWR(
    `/blog/posts/category/${categoryId}/?page=${page}&search=${search}`,
    nextAPIfetcher,
    { initialData: page === 1 ? posts : undefined },
  );

  return (
    <div className={classes.root}>
      <SectionAlternate className={classes.sectionBreadcrumb}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link href="/blog">
            <a>
              <Typography color="textSecondary">Blog</Typography>
            </a>
          </Link>
          <Typography color="textPrimary">{category.data?.name}</Typography>
        </Breadcrumbs>
      </SectionAlternate>
      <Section className={classes.sectionSearch}>
        <Hero category={category} loading={!data || isValidating} />
      </Section>
      <SectionAlternate>
        <Results data={data} />
      </SectionAlternate>
    </div>
  );
}

BlogCategory.propTypes = {
  doc: PropTypes.object,
};
